/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-11-26 23:11:28
 */
import request from '@/utils/request'
import { ADMIN_SERVICE_URL } from '@/utils/constant'
export function list(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/appVersion`,
    method: 'get',
    params: queryParams
  })
}

export function detail(id) {
  return request({
    url: `${ADMIN_SERVICE_URL}/appVersion/` + id,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/appVersion`,
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/appVersion/` + id,
    method: 'put',
    data: data
  })
}

export function del(ids) {
  return request({
    url: `${ADMIN_SERVICE_URL}/appVersion/` + ids,
    method: 'delete'
  })
}

export function patch(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/appVersion/` + id,
    method: 'patch',
    data: data
  })
}
